import React, { Children } from 'react'

import { currencies } from '../../lib/currencies'
import axios from 'axios'


// for modal bulk revshares
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Checkbox from '@material-ui/core/Checkbox';
import Modal from '@material-ui/core/Modal'
import { runInThisContext } from 'vm'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


function getBulkRevshareModalStyle() {
    const top = 50
    const left = 50

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
        position: 'absolute',
        width: 1100,
        minHeight: 400,
        backgroundColor: 'white',
        border: '1px solid #000',
        boxShadow: '1px solid ',
        padding: '10px'
    }
}



class BulkRevshareModal extends React.Component<any, any> {
    constructor(props: any) {
        super(props)


        this.state = {
            showBulkRevhsareModal: false,
            bulkRevshareModalStyle: {},
            bulkRevshare: {
                partnerId: null,
                currencies: [],
                revshare: 80,
            },
            loading: false,

        }
    }

    resetState() {
        this.setState({
            bulkRevshareModalStyle: getBulkRevshareModalStyle(),
            showBulkRevhsareModal: false,
            bulkRevshare: {
                  partnerId: this.props.partner.partnerId,
                  currencies: [],
                  revshare: 80,
            },
            loading: false,
        })
    }

    componentDidMount(){
        console.log("this.props.partner ", this.props.partner)

        this.resetState()


        /*let bulkRevshare = this.state.bulkRevshare
        bulkRevshare.partnerId = this.props.partner.partnerId
        this.setState({
            bulkRevshare: bulkRevshare,
        })*/

    }

    onRevenueShareBulkSave() {
        console.log('onRevenueShareBulkSave')

        this.setState({ loading: true }, () => {
            axios
                .request({
                    url: '/revshare/bulk',
                    method: 'POST',
                    data: this.state.bulkRevshare
                })
                .then(response => {
                    this.resetState()
                    this.props.onCloseModal()
                    this.props.reloadRevshares()
                })
                .catch(error => {
                    this.setState({ loading: false })
                    console.log(error)
                })
        });

    }

    // conditional rendering based on state (loaded async from external api call)
    render() {
        return (

            <Modal
                open={this.props.showBulkRevhsareModal}
                onClose={() => {
                    this.props.onCloseModal();
                    this.resetState()
                    }
                }
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description">
                <div style={this.state.bulkRevshareModalStyle}>
                    <h2 id="simple-modal-title">Bulk Create Revshares
                        <button  onClick={()=> this.props.onCloseModal()} className="border-button inlinebuttons" style={{
                            'float': 'right',
                            'minWidth': '30px',
                            'width': '30px',
                            'height': '30px',
                            'border': '0px',
                            }}>X</button>
                    </h2>
                    <p id="simple-modal-description">
                        <p style={{'fontSize': 'smaller', 'color': 'grey'}}>Create some revenue shares for each product we support and for all the currencies you select.</p>

                        <div className="row" style={{ marginTop: '30px' }}>
                            <div className="col">
                                <label>Partner Id:</label>

                                <div>
                                    {this.state.bulkRevshare.partnerId}
                                </div>

                            </div>
                        </div>
                        <div className="row" style={{ marginTop: '30px' }}>
                            <div className="col">
                                <label>Currencies:</label>
                                <Autocomplete
                                    multiple
                                    disableCloseOnSelect
                                    size="small"
                                    style={{ width: '100%' }}
                                    id={'currencies-select-' + new Date().getTime()}

                                    options={currencies}
                                    autoHighlight
                                    getOptionLabel={option => option}
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            let bulkRevshare = this.state.bulkRevshare
                                            bulkRevshare.currencies = newValue
                                            this.setState({bulkRevshare: bulkRevshare})
                                        }
                                    }}

                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8, color: '#2768EF' }}
                                                checked={selected}
                                            />
                                            {option}
                                        </React.Fragment>
                                    )}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Choose a currency"
                                            variant="outlined"
                                            inputProps={{
                                                ...params.inputProps,
                                                autoComplete: 'new-password', // disable autocomplete and autofill
                                                form: {
                                                    autocomplete: 'off'
                                                }
                                            }}
                                        />
                                    )}
                                />

                            </div>
                        </div>
                        <div className="row" style={{ marginTop: '30px' }}>
                            <div className="col">
                                <label>Revshare %:</label>
                                <input
                                    type="number"
                                    max="100.0"
                                    min="0.0"
                                    className="form-control"
                                    id="revShare"
                                    value={this.state.bulkRevshare.revshare}
                                    onChange={event => {
                                        //console.log("change revshare", parseFloat(event.target.value))
                                        let bulkRevshare = this.state.bulkRevshare
                                        bulkRevshare.revshare = parseFloat(event.target.value)
                                        this.setState({ bulkRevshare: bulkRevshare })
                                    }}
                                />

                            </div>
                        </div>
                        <div className="row" style={{ marginTop: '20px' }}>
                            <div className="col text-right">

                                <button disabled={
                                        this.state.bulkRevshare.partnerId == null || this.state.bulkRevshare.currencies.length == 0
                                    }
                                    onClick={() => this.onRevenueShareBulkSave()} className="border-button inlinebuttons" >
                                    <span style={{'whiteSpace': 'nowrap'}}>
                                        {this.state.loading && (
                                            <span className="login-loading-wrapper">
                                                <i className="fa fa-spin fa-spinner" />
                                            </span>
                                        )}
                                        &#160;Save
                                    </span>
                                </button>



                            </div>
                        </div>

                    </p>
                </div>
            </Modal>

        );
    }
}

export default BulkRevshareModal
